module.exports = __webpack_public_path__ + "static/media/TikTok_Chin_Android.a0d9d951.pdf";